import { Component, OnInit, Input, HostListener, OnDestroy } from '@angular/core';
import { GamificationLeagueDto } from '../../shared/types/GamificationLeagueDto';
import { GamificationSettingsDto } from '../../shared/types/GamificationSettingsDto';
import { LeaderboardStatusType } from '../../shared/types/leaderboard-status-type';
import { LevelProgressDto } from '../../shared/types/LevelProgressDto';

@Component({
  selector: 'lp2-progress-page-progress-section',
  templateUrl: './progress-page-progress-section.component.html',
  styleUrls: ['./progress-page-progress-section.component.scss', '../progress-page/progress-page.scss'],
})
export class ProgressPageProgressSectionComponent implements OnInit, OnDestroy {
  @Input() levelProgress: LevelProgressDto;
  @Input() indexUrl: string;
  @Input() leagues: GamificationLeagueDto[];
  @Input() gamificationSettings: GamificationSettingsDto;
  @Input() leaderboardStatus: LeaderboardStatusType;

  isLowRes: boolean;
  lowResTimer;

  @HostListener('window:resize', ['$event'])
  resizeEvent() {
    this.calculateLowRes();
  }

  constructor() {}

  calculateLowRes() {
    this.clearLowResTimer();
    this.lowResTimer = setTimeout(() => {
      this.isLowRes = document.documentElement.clientWidth < 711;
    }, 100);
  }

  ngOnInit() {
    this.calculateLowRes();
  }

  ngOnDestroy() {
    this.clearLowResTimer();
  }

  private clearLowResTimer() {
    if (this.lowResTimer) {
      clearTimeout(this.lowResTimer);
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/progress/progress-page-progress-section/progress-page-progress-section.component.ts